import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { ButtonGroup, Form, FormGroup, Label, Col, Row } from "reactstrap";

import { ROUTES, insertIdtoUrl } from "constants/Routes.js";
import "assets/scss/customRadio.css";
import {userFormValidator, inputFocusHandler} from 'utils/userFormValidate';

class BusinessUserInvitationForm extends Component {
  render() {
    const {email,role} = this.props.user;
    return (
      <div className="user-form mt-3" id='userForm'>
        <Form onSubmit={this.props.handleSubmit}>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Email</Label>
                <input
                  type='email'
                  className="form-control"
                  name="email"
                  value={email}
                  onChange={this.props.handleChange}
                  onBlur={inputFocusHandler} required
                />
                <div className='row error' id='emailError'></div>
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Role</Label>:
                <FormGroup>
                  <Label className="radio-container">
                    <span className="answer-title">Admin</span>
                    <input
                      type="radio"
                      name="role"
                      id="admin"
                      value="admin"
                      checked={role == "admin"||role=='' ? "true" : ""}
                      onChange={this.props.handleChange}
                    />
                    <span className="radiomark" />
                  </Label>

                  <Label className="radio-container">
                    <span className="answer-title">Manager</span>
                    <input
                      type="radio"
                      name="role"
                      id="user"
                      value="manager"
                      checked={role == "manager" ? "true" : ""}
                      onChange={this.props.handleChange}
                    />
                    <span className="radiomark" />
                  </Label>
                </FormGroup>
              </FormGroup>
            </Col>
          </Row>
          <div className="float-right">
            <button
            type='submit'
            onClick={userFormValidator?this.props.addUserInvitation:''}
              className={`btn btn-secondary mr-1${
                this.props.create ? "" : "d-none"
              }`}
            >
              Create
            </button>
            <NavLink
              to={insertIdtoUrl(ROUTES.USERS_LIST, this.props.businessId)}
            >
              <span className="btn btn-add">Cancel</span>
            </NavLink>
          </div>
        </Form>
      </div>
    );
  }
}

export default BusinessUserInvitationForm;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/business-users/invitation/BusinessUserInvitationForm.js